module.exports = __webpack_public_path__ + "img/people-roof.be8dedba.svg";